import React from 'react';
import './App.css';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from "./services/config/gamecentreService";
import { NEW_DATA_EVENT } from './services/consts';
import { storage } from './services/config/storage';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

function App() {
  const gameRef = React.createRef();
  const [gameDetails, setGameDetails] = React.useState(null);
  const gameInIframe = (window.location !== window.parent.location);

  /**  
   *  Render game if any two conditions met 
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName } 
  */
  React.useEffect(() => {
    if ((!gameInIframe) || (gameDetails)) {
      const container = gameRef.current;
      // dynamically importing Game module
      // This way it won't run the module before checking game in iframe/gameDetails if loaded in iframe
      import("./Game")
        .then((Game) => {
          container.appendChild(Game.default.view);
        })
        .catch((error) => console.error("Error in loading game", error));
    } 
  }, [gameRef, gameDetails]);

  React.useEffect(() => {
    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }
    // Send mount/load event to assessment centre to get token and gameplayId (linkId)
    GC.sendGameLoadMessage();
       
    window.addEventListener("message", GC.messageEventHandler);
    window.addEventListener(NEW_DATA_EVENT, syncData);
    window.addEventListener("blur", handleBlur)
    return () => {
      window.removeEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    }
  }, []);

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }
  
  return (
    <div className="App">
      <div ref={gameRef} className="Game"></div>
    </div>
  );
}

export default App;
